export enum UpliftType {
  Percent = "Percent",
  Amount = "Amount",
}
export interface LibraryUplift {
  id: number;
  reason: string;
}

export interface Uplift {
  id: number;
  amount: number;
  type: UpliftType;
  baseUplift?: LibraryUplift | null;
  baseUpliftId?: number;
  order: number;
  autoFocus?: boolean | null;
  includeOnProposal?: boolean | null;
}

export interface UpliftInput {
  id: number;
  amount: number;
  type: UpliftType;
  baseUpliftId: number;
  includeOnProposal?: boolean | null;
}

export type LibraryUplifts = Record<string, LibraryUplift[]>;

export interface UpliftBreakdownSingle {
  partialTotal: number;
  visibleTotal: number;
  fullTotal: number;
}

export interface UpliftBreakdownRange {
  partialTotal: { lower: number; upper: number };
  visibleTotal: { lower: number; upper: number };
  fullTotal: { lower: number; upper: number };
}

export type UpliftBreakdown = UpliftBreakdownSingle | UpliftBreakdownRange;
